/**
 * @generated SignedSource<<921fae3da9b4470c42cf97544817c35f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MutationsDeleteSchemaKVPMutation$variables = {
  id: number;
  key: string;
};
export type MutationsDeleteSchemaKVPMutation$data = {
  readonly deleteSchemaKVP: boolean;
};
export type MutationsDeleteSchemaKVPMutation = {
  response: MutationsDeleteSchemaKVPMutation$data;
  variables: MutationsDeleteSchemaKVPMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteSchemaKVP",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MutationsDeleteSchemaKVPMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MutationsDeleteSchemaKVPMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "76c6724c2847f81c38d683b1976184d2",
    "id": null,
    "metadata": {},
    "name": "MutationsDeleteSchemaKVPMutation",
    "operationKind": "mutation",
    "text": "mutation MutationsDeleteSchemaKVPMutation(\n  $id: Int!\n  $key: String!\n) {\n  deleteSchemaKVP(id: $id, key: $key)\n}\n"
  }
};
})();

(node as any).hash = "66f3cdf68262fbe13b19f4fc4729fdd6";

export default node;
